import React, { useState, useRef, useEffect } from "react";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db } from "../firebase";
import { v4 as uuidv4 } from "uuid";
import {
  Container,
  Card,
  CardContent,
  Box,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import stringSimilarity from "string-similarity";
import {
  collection,
  doc,
  getDocs,
  where,
  updateDoc,
  query,
  serverTimestamp
} from "firebase/firestore/lite";
import MySpinner from "./MySpinner";
import { AudioWrapper, FINISH, LISTENING_TEST, convertToHTML } from "./helper";
import https from "https";
import SoftBox from "./SoftBox";
import SoftTypography from "./SoftTypography";
import SoftButton from "./SoftButton";
import adapter from "webrtc-adapter";
import TagManager from "react-gtm-module";
import "../audioRecorder.css";
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import filledInfoLogo from "../assets/images/small-logos/Filled-info.png";
// const isIPhone =
//   adapter.browserDetails.browser === "safari" &&
//   adapter.browserDetails.version < 14;
const isIPhone = /iPhone|iPad|iPod/.test(navigator.userAgent) &&
                adapter.browserDetails.browser === "safari";

const useStyles = makeStyles((theme) => ({
  root: {
    animation: "$blink 2s linear infinite",
  },
  "@keyframes blink": {
    "0%": {
      opacity: 0.5,
    },
    "50%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0.5,
    },
  },
}));

const AudioRecorder1 = ({ assessment, handleNextStep, region, questions, category, test, nextSectionName, passage  }) => {
  const [passage1, setPassage1] = useState("");
  const [passage2, setPassage2] = useState("");
  const [passage3, setPassage3] = useState("");
  const [permission, setPermission] = useState(true);
  const [stream, setStream] = useState(null);
  const mediaRecorder = useRef(null);
  const [recordingStatus, setRecordingStatus] = useState("inactive");
  const [audioChunks, setAudioChunks] = useState([]);
  const [audio, setAudio] = useState(null);
  const [audioBlob, setAudioBlob] = useState([]);
  const [loading, setLoading] = useState(true);
  const [timer, setTimer] = useState(120);
  const [countdown, setCountdown] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: "component_loaded",
        component: "RecordingAccessment",
        passage: passage
      },
    });
  }, []);

  useEffect(() => {
    // setLoading(true);
    getMicrophonePermission();
    setLoading(false)
    // const q = query(
    //   collection(db, "reading_passages"),
    //   where("region", "==", region)
    // );
    // getDocs(q)
    //   .then((docSnapshot) => {
    //     const docArray = docSnapshot.docs.map((doc) => doc.data());
    //     const randomIndex = Math.floor(Math.random() * docArray.length);
    //     setPassage1(docArray[randomIndex].passage1);
    //     setPassage2(docArray[randomIndex].passage2);
    //     setPassage3(docArray[randomIndex].passage3);
    //     setLoading(false);
    //     getMicrophonePermission();
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //   });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getMicrophonePermission = async () => {
    try {
      if ("MediaRecorder" in window) {
        const constraints = isIPhone
          ? { audio: true }
          : { audio: true, video: false };
        const streamData = await navigator.mediaDevices.getUserMedia(constraints);
        setPermission(true);
        setStream(streamData);
      } else {
        alert("The MediaRecorder API is not supported in your browser.");
      }
    } catch (err) {
      // iPhone-specific instructions
      if (isIPhone) {
        alert(
          err.message +
            "\n " +
            "Go to the general Settings on your device." +
            "\n" +
            "Find and select Safari." +
            "\n " +
            "Scroll down to Setting for All Websites, and select Camera or Microphone." +
            "\n " +
            "Set Camera Access on All Websites or Microphone Access on All Websites to Allow." +
            "\n " +
            "Refresh the page."
        );
      } else {
        // Generic alert for non-iPhone devices
        alert("Microphone access is required. Please allow access in your browser settings.");
      }
      setPermission(false); // Explicitly set permission to false if denied
    }
  };
    
  // const mimeType = "audio/mp4";
  const mimeType = isIPhone ? "audio/mp4" : "audio/webm";

  const startRecording = async () => {
    if (!permission) {
      // Attempt to get permission again
      await getMicrophonePermission();
      return; // Exit function until permission is granted
    }
  
    try {
      setRecordingStatus("recording");
      // Update bars every 300ms to mimic real-time changes
      setInterval(animateBars, 300);

      const media = new MediaRecorder(stream, { type: mimeType });
      mediaRecorder.current = media;
      mediaRecorder.current.start();
  
      let localAudioChunks = [];
      mediaRecorder.current.ondataavailable = (event) => {
        if (typeof event.data === "undefined") return;
        if (event.data.size === 0) return;
        localAudioChunks.push(event.data);
      };
      setAudioChunks(localAudioChunks);
    } catch (err) {
      console.error("Error during recording:", err);
    }
  };
  
  const [totalBars, setTotalBars] = useState(40);
  const [isBelow992, setIsBelow992] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      // Set totalBars based on screen width
      if (width > 1200) {
        setTotalBars(40);
      } else if (width > 992) {
        setTotalBars(30);
      } else if (width > 768) {
        setTotalBars(30);
      } else if (width > 534) {
        setTotalBars(20);
      } else {
        setTotalBars(15);
      }

      setIsBelow992(width <= 992);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const animateBars = () => {
    const bars = document.querySelectorAll(".dark-bar");
    bars.forEach(bar => {
        const randomHeight = Math.floor(Math.random() * 30) + 5; // Random height between 10px to 35px
        bar.style.height = `${randomHeight}px`;
    });
  };

  useEffect(() => {
    let interval;
    if (recordingStatus === "recording") {
      const currentCategory = region['tests'][test]['sections'].find((item) => item.field === category);
      const timeLimit = currentCategory?.time_limit || 120;
      // const timeLimit = 20;
      interval = setInterval(() => {
        setTimer((prevTime) => {
          if (prevTime >= timeLimit - 1) {
            stopRecording();
            return timeLimit - 1;
          }
          const newTime = prevTime + 1;
          if (newTime >= timeLimit - 15) {
            setCountdown(timeLimit - newTime);
          }
          return prevTime + 1;
        });
      }, 1000);
    } else {
      clearInterval(interval);
      setTimer(0);
    }
    //Resetting the countdown when user clicks on re-record or when resets the timer
    if (recordingStatus === 'inactive') {
      setCountdown(null)
    }
    return () => clearInterval(interval);
  }, [recordingStatus, category]);  
  
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")} : ${String(secs).padStart(2, "0")}`;
  };   

  const stopRecording = () => {
    setRecordingStatus("inactive");
    //stops the recording instance
    mediaRecorder.current.stop();
    mediaRecorder.current.onstop = () => {
      //creates a blob file from the audiochunks data
      const audioBlob = new Blob(audioChunks, { type: mimeType });
      setAudioBlob(audioBlob);
      //creates a playable URL from the blob file.
      const audioUrl = URL.createObjectURL(audioBlob);
      setAudio(audioUrl);
      setAudioChunks([]);
    };
  };

  const submitAudio = async () => {
    
    setLoading(true);
    try {
      if (audio) {
        const formData = new FormData();
        formData.append("audio", await fetch(audio).then((r) => r.blob()));
        formData.append("assessment_uid", assessment.uid);
        formData.append("passage", passage);
        formData.append("user_id", assessment.userId);
        formData.append("nextStep", nextSectionName);
    
        // Make the fetch call
        const response = await fetch(process.env.REACT_APP_SERVER_URL + "/update_transcribe", {
          method: "POST",
          body: formData,
          agent: new https.Agent({
            rejectUnauthorized: false,
            requestCert: false,
            agent: false,
          }),
        });
  
        // Check if the response is OK (status 200-299)
        if (response.ok) {
          const data = await response.json();
          setAudio(null);
          handleNextStep();

        } else {
          // Handle the case where the response is not successful
          console.error("Failed to submit audio:", response.statusText);
        }
  
      } else {
        console.error("No audio file selected.");
      }
    } catch (error) {
      // Catch any errors during the process
      console.error("Error occurred while submitting audio:", error);
    } finally {
      // Make sure to stop the loading indicator in both success and error cases
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div>
        <MySpinner />
      </div>
    );
  }

  return (
    <>
      <Container sx={{backgroundColor: "#FFFFFF", borderRadius: "0px", padding: "0px !important", margin: "-30px auto 20px auto !important"}}>
        <div style={{backgroundColor: "#FFFFFF", padding: "0 20px 5px 20px"}}>
          <SoftBox mt={1} mb={1} style={{backgroundColor: "#FFFFFF"}}>
            <SoftTypography variant="body1" fontWeight="bold" color="dark">
              <div style={{display:"flex"}}>
                <p style={{flex:"0.5", color: "rgba(79, 79, 79, 1)", fontSize: "24px", fontWeight: "700"}}>{category.startsWith("speaking_") ? 'Speaking' : category.startsWith("audio_scenario_") ? 'Scenario Response' : 'Reading'}</p>
              </div>
            </SoftTypography>
          </SoftBox>
          <SoftBox mb={1} style={{backgroundColor: "#FFFFFF"}}>
            <SoftTypography variant="body2" fontWeight="medium" color="dark" style={{color: "rgba(132, 132, 132, 1)", fontSize: "16px", fontWeight: "400"}}>
              {category.startsWith("speaking_") ?
              'This section tests fluency, pronounciation, coherence, and interaction skills.' :
              category.startsWith("audio_scenario_") ?
              'Read the scenario below carefully, then record your professional response as if you were speaking directly to the customer.' :
              'Record yourself reading the paragraph below'}
            </SoftTypography>
          </SoftBox>
        </div>
      </Container>
      <Container sx={{borderRadius: "0px", padding: "0px !important"}}>
      <SoftBox>
        {(category.startsWith("speaking_") || category.startsWith("audio_scenario_")) && questions ? (
         questions.map((question, index) => { 

          let sectionDescription = "";
          let sectionTimeLimit = 0;
          const sections = region?.tests[test]?.sections || [];

          // Get only categories that start with "speaking_"
          const speakCategories = sections
            .map(section => section.field)
            .filter(field => field.startsWith("speaking_") || field.startsWith("audio_scenario_"));

          // Get the current category's position within "speaking_" categories
          const speakCategoryIndex = speakCategories.indexOf(category) + 1; // 1-based index
          const totalSpeakCategories = speakCategories.length; // Total "speaking_" categories

          if (sections) {
            sections.forEach((section) => {

              if (section.field === category) {
                sectionDescription = section.description;
                sectionTimeLimit = section.time_limit         
              }
            });
          }

          const formattedTime = sectionTimeLimit < 60 
          ? `${sectionTimeLimit} seconds` 
          : `${Math.floor(sectionTimeLimit / 60)} minutes ${sectionTimeLimit % 60 > 0 ? sectionTimeLimit % 60 + " seconds" : ""}`;

          return(
          <>
            {sectionDescription && formattedTime && questions && (
              <div
                style={{
                  fontWeight: 700,
                  borderRadius: "8px",
                  marginBottom: "10px",
                  padding: "12px 20px",
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  fontSize: "20px",
                  color: "rgba(79, 79, 79, 1)",
                  backgroundColor: "rgba(221, 225, 251, 1)"
                }}
              >
                <div style={{ marginBottom: isMobile ? "10px" : "0", flex: isMobile ? "unset" : "0.5" }}>
                  {sectionDescription}
                </div>
                <div
                  style={{
                    display: "flex",
                    // justifyContent: isMobile ? "flex-start" : "flex-end",
                    justifyContent: "flex-end",
                    flex: isMobile ? "unset" : "0.5",
                    marginRight: isMobile ? "0" : "20px",
                  }}
                >
                  {category.startsWith("audio_scenario_") ? `Around ${formattedTime}` : `Maximum ${formattedTime}`}
                </div>
              </div>
            )}
            <Card
              mb={2}
              variant="outlined"
              style={{borderRadius: "8px", boxShadow: "none"}}
            >
              <SoftBox lineHeight={0}>
                <SoftBox
                  pl={1}
                  style={{ backgroundColor: "rgba(234, 234, 234, 1)" }}
                >
                  <SoftTypography
                    variant="h6"
                    fontWeight="medium"
                    color="dark"
                    style={{ padding: "15px", color: "rgba(79, 79, 79, 1)", fontSize: "18px", fontWeight: "700" }}
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: convertToHTML(questions[0].question) }}
                    ></div>
                  </SoftTypography>
                  {!category.startsWith("audio_scenario_") && <SoftTypography
                    variant="h6"
                    fontWeight="medium"
                    color="dark"
                    style={{ padding: "0 15px 5px 15px", color: "rgba(79, 79, 79, 1)", fontSize: "16px", fontWeight: "700" }}
                  >
                    {"What to include in your response:"}
                  </SoftTypography>}
                  <SoftTypography
                    variant="h6"
                    fontWeight="medium"
                    color="dark"
                    style={{ padding: "0px 15px", color: "rgba(79, 79, 79, 1)", fontSize: "16px", fontWeight: "400" }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `
                          <style>
                            ul {
                              list-style-type: disc;
                              padding-left: 25px;
                            }
                            li {
                              margin-bottom: 5px;
                            }
                          </style>
                          ${questions[0].description}
                        `,
                      }}
                    />
                  </SoftTypography>
                  {/* <SoftTypography
                    variant="h6"
                    fontWeight="medium"
                    color="dark"
                    style={{ padding: "5px 15px 5px 15px", color: "rgba(79, 79, 79, 1)", fontSize: "16px", fontWeight: "400" }}
                  >
                    {"Example Response:"}
                  </SoftTypography> */}
                  {/* <SoftTypography
                    variant="h6"
                    fontWeight="medium"
                    color="dark"
                    style={{ padding: "0 15px 5px 15px", color: "rgba(79, 79, 79, 1)", fontSize: "16px", fontWeight: "400" }}
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: convertToHTML(questions[0].eg_resp) }}
                    ></div>
                  </SoftTypography> */}
                  {category.startsWith("speaking_") && totalSpeakCategories > 0 && (
                    <SoftTypography
                      variant="h6"
                      fontWeight="medium"
                      color="dark"
                      style={{ padding: "0 0 20px 0" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          padding: "5px 15px",
                          height: "15px",
                          fontWeight: 400,
                          fontSize: "1rem",
                          marginTop: "2px",
                          marginBottom: "4px",
                          bgColor: "grey-100",
                          color: "rgba(79, 79, 79, 1)"
                        }}
                      >                    
                        {`Q ${speakCategoryIndex} of ${totalSpeakCategories}`}
                      </div>
                    </SoftTypography>
                  )}
                </SoftBox>
              </SoftBox>
            </Card>

            {recordingStatus === "inactive" ? (
              <SoftBox mt={2} mb={1} bgColor="white" fullWidth style={{ padding: '15px' }}>
                <SoftButton
                  sx={{
                    transition: 'none',
                    '&:hover': {
                      backgroundColor: '#f8f9fa',
                      transform: 'none'
                    }
                  }}
                  style={{
                    width: '100%',
                    borderRadius: '50px',
                    margin: 'auto',
                    backgroundColor: '#f8f9fa',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: '10px'
                  }}
                >
                  {/* Row: button + audio/timer */}
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      alignItems: 'center',
                      flexDirection: isMobile ? 'column' : 'row',
                    }}
                  >
                  <SoftButton
                    color="gt_primary"
                    onClick={startRecording}
                    disabled={!permission}
                    sx={{
                      transition: 'none',
                      textTransform: 'none',
                      fontSize: '16px',
                      fontWeight: '600',
                      '&:hover': {
                        backgroundColor: '#5569ED',
                        transform: 'none'
                      }
                    }}
                    style={{
                      width: '100%',
                      borderRadius: '50px',
                      height: '40px',
                      display: 'flex',
                      flex: audio !== null ? '0.12' : '0.9',
                      justifyContent: 'flex-start',
                      marginBottom: isMobile && !audio ? '10px' : 0
                    }}
                  >
                    <div style={{
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(206, 206, 206, 1)',
                      border: '1px solid white',
                      marginRight: '15px'
                    }} />
                    {audio !== null ? "Re record" : "Press to start the recording"}
                  </SoftButton>

                  {audio && audio !== null ? (
                    <AudioWrapper
                      style={{
                        flex: isMobile ? 'unset' : '0.88',
                        margin: isMobile ? '10px 0 0 0' : 'auto 10px',
                        height: '41px',
                        width: isMobile ? '100%' : 'auto'
                      }}
                    >
                      <audio controls src={audio}></audio>
                    </AudioWrapper>
                  ) : (
                    <div
                      style={{
                        textAlign: isMobile ? 'center' : 'left',
                        fontSize: '16px',
                        fontWeight: '600',
                        color: 'rgba(79, 79, 79, 1)',
                        marginLeft: isMobile ? 0 : '16px'
                      }}
                    >
                      {'00 : 00'}
                    </div>
                  )}
                </div>

                <Box
                  p={1.5}
                  pt={0}
                  pl={2.7}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    fontSize: "16px",
                    fontWeight: "400",
                    color: "#848484",
                    width: "fit-content",
                    marginTop: "8px",
                  }}
                >
                  <img
                    src={filledInfoLogo}
                    alt="Info Icon"
                    style={{
                      marginRight: "12px",
                      marginTop: "3px",
                    }}
                  />
                  <span style={{ textTransform: "none", lineHeight: "1.5", textAlign: "start" }}>
                    Your recording has a{" "}
                    <span style={{ color: "#848484", fontSize: "16px", fontWeight: "700" }}>
                      {formattedTime.replace(" ", "-")}
                    </span>{" "}
                    limit. Be advised, responses{" "}
                    <span style={{ color: "#848484", fontSize: "16px", fontWeight: "700" }}>
                      under 1 minute will not be accepted as a valid answer.
                    </span>{" "}
                    Use your time to deliver a thorough response.
                  </span>
                </Box>
                </SoftButton>
              </SoftBox>
            ) : null}

            {recordingStatus === "recording" ? (
              <SoftBox mt={2} mb={1} bgColor="white" fullWidth style={{ padding: '15px' }}>
                <SoftButton
                  sx={{
                    transition: 'none',
                    '&:hover': {
                      backgroundColor: '#f8f9fa',
                      transform: 'none'
                    }
                  }}
                  style={{
                    width: '100%',
                    borderRadius: '50px',
                    margin: 'auto',
                    backgroundColor: '#f8f9fa',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: '10px'
                  }}
                >
                  {/* Row: Stop button + waveform + timer */}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: isBelow992 ? 'column' : 'row',
                      width: '100%',
                      alignItems: isBelow992 ? 'flex-start' : 'center',
                    }}
                  >
                    <SoftButton
                      className="record-button"
                      onClick={stopRecording}
                      sx={{
                        display: 'flex !important',
                        width: isBelow992 ? '100%' : '22%',
                        placeContent: 'flex-start',
                        transition: 'none',
                        textTransform: 'none',
                        fontSize: '14px',
                        fontWeight: '500',
                        '&:hover': {
                          backgroundColor: '#5569ED',
                          transform: 'none',
                        },
                      }}
                      style={{
                        marginBottom: isBelow992 ? '12px' : 0,
                      }}
                    >
                      Press again to stop
                    </SoftButton>

                    <div
                      className="recorder-container"
                      style={{
                        marginLeft: isBelow992 ? '0' : '16px',
                        flex: isBelow992 ? 'unset' : 1,
                        width: isBelow992 ? '100%' : 'auto',
                      }}
                    >
                    <div
                      className="sound-wave"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        width: '100%',
                        marginTop: isBelow992 ? '12px' : 0
                      }}
                    >
                      {Array.from({ length: totalBars }).map((_, index) => (
                        <div key={index} className="bar-container">
                          <div className="light-bar"></div>
                          <div className="dark-bar"></div>
                        </div>
                      ))}
                      <div
                        style={{
                          textAlign: 'center',
                          fontSize: '14px',
                          marginLeft: '12px',
                          color: countdown > 0 ? 'red' : 'inherit',
                        }}
                      >
                        {formatTime(timer)}
                      </div>
                    </div>
                  </div>
                </div>

                  {/* Row: countdown warning below */}
                  {countdown !== null && countdown >= 0 && (
                  <Box
                    p={1.5}
                    borderRadius="30px"
                    sx={{
                      backgroundColor: "#FFF7E6",
                      display: "flex",
                      alignItems: "flex-start",
                      fontWeight: "400",
                      fontSize: "16px",
                      color: "#CC8A01",
                      width: "fit-content",
                      marginTop: '8px',
                      lineHeight: "1.4"
                    }}
                  >
                    <ReportProblemRoundedIcon 
                      style={{ 
                        marginTop: "3px",
                        marginLeft: "2px",
                        marginRight: "8px",
                        color: "#FFAD01",
                        fontSize: "22px"
                      }} 
                    />
                    <span style={{ textTransform: "none", textAlign: "start" }}>
                      You have only{" "}
                      <span 
                        style={{
                          fontWeight: "700",
                          display: "inline-block",
                          minWidth: "40px",
                          textAlign: "center",
                          fontVariantNumeric: "tabular-nums"
                        }}
                      >
                        {countdown} second{countdown !== 1 ? 's' : ''}
                      </span>{" "}
                      to complete your recording. Please wrap up your response promptly
                    </span>
                  </Box>
                )}
                </SoftButton>
              </SoftBox>
            ) : null}

            <SoftBox mt={1} mb={2}>
              <SoftBox mt={2} mb={1}>
                <SoftButton
                  variant="contained"
                  color="gt_primary"
                  onClick={submitAudio}
                  fullWidth
                  disabled={recordingStatus === "recording" || audio === null}//Disabling the next button if audio is null or user is still recording
                  sx={{
                    "&.Mui-disabled": {
                      opacity: "0.6",
                    },
                  }}
                >
                  {nextSectionName === "Finish" ? "Submit" : "Next"}
                </SoftButton>
              </SoftBox>
            </SoftBox>
          </>);
        })
      ) : (
        <>
        {recordingStatus === "recording" ? (
          <SoftBox mt={1} mb={2}>
            <SoftButton
              variant="gradient"
              color="warning"
              onClick={stopRecording}
              fullWidth
              className={classes.root}
            >
              Stop Recording
            </SoftButton>
          </SoftBox>
        ) : null}
        <Card key={1} style={{ marginBottom: 20 }}>
          <CardContent>
            <SoftBox mt={2}>
              <SoftTypography variant="h6" fontWeight="medium" color="text">
                <div
                  dangerouslySetInnerHTML={{ __html: convertToHTML(passage) }}
                ></div>
              </SoftTypography>
            </SoftBox>
          </CardContent>
        </Card>

        {recordingStatus === "inactive" ? (
          <SoftBox mt={2} mb={1}>
            <SoftButton
              variant="contained"
              color="gt_primary"
              onClick={startRecording}
              disabled={!permission}
              fullWidth
            >
              {audio !== null ? "Re-Recording" : "Start Recording"}
            </SoftButton>
          </SoftBox>
        ) : null}
        {recordingStatus === "recording" ? (
          <SoftBox mt={2} mb={1}>
            <SoftButton
              variant="gradient"
              color="warning"
              onClick={stopRecording}
              fullWidth
              className={classes.root}
            >
              Stop Recording
            </SoftButton>
          </SoftBox>
        ) : null}

        {audio ? (
          <AudioWrapper>
            <audio controls src={audio}></audio>
          </AudioWrapper>
        ) : null}
        {audio ? (
          <SoftBox mt={1} mb={1}>
            <SoftTypography variant="body2" fontWeight="medium" color="dark">
              If you are happy with your recording click next
            </SoftTypography>
          </SoftBox>
        ) : null}
        <SoftBox mt={1} mb={2}>
          <SoftBox mt={2} mb={1}>
            <SoftButton
              variant="contained"
              color="gt_primary"
              onClick={submitAudio}
              fullWidth
              disabled={recordingStatus === "recording" || audio === null}//Disabling the next button if audio is null or user is still recording
              sx={{
                "&.Mui-disabled": {
                  opacity: "0.6",
                },
              }}
            >
              {nextSectionName === "Finish" ? "Submit" : "Next"}
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </>
      )
      }
      </SoftBox>
    </Container>
    </>
  );
};

export default AudioRecorder1;
